function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { primary200, primary600, gray50, gray100, gray400, gray800, focusShadow } from '../../theme/colors';
import { fontSemiBold } from '../../theme/fonts';
import { size8, size12, size14, size20, size24, size32, size48 } from '../../theme/scale';
import { duration150, easeInOut } from '../../theme/animation';
import { elevationThree } from '../../theme/elevations';
import { labelFontSize } from "../../utils/helpers";
const ToggleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: ${size24};
  margin-right: ${({
  hideLabel
}) => hideLabel ? '0' : size14};
  position: relative;
  width: ${size32};
`;
const ToggleTrack = styled.div`
  background: ${gray400};
  border-radius: ${size48};
  height: ${size14};
  width: 100%;
`;
const Toggle = styled.div`
  background: ${gray50};
  border-radius: 50%;
  height: ${size20};
  position: absolute;
  transform: translateX(0);
  transition: transform ${duration150} ${easeInOut}, background ${duration150} ${easeInOut};
  width: ${size20};
  ${({
  disabled
}) => !disabled && `box-shadow: ${elevationThree};`}
`;
const Input = styled.input`
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;

  &:checked {
    ~ ${ToggleWrapper} {
      ${ToggleTrack} {
        background: ${primary200};
      }

      ${Toggle} {
        background: ${primary600};
        transform: translateX(${size12});
      }
    }

    &:disabled {
      ~ ${ToggleWrapper} {
        ${ToggleTrack} {
          background: ${gray100};
        }

        ${Toggle} {
          background: ${primary200};
        }
      }
    }
  }

  &:disabled {
    ~ ${ToggleWrapper} {
      ${ToggleTrack} {
        background: ${gray100};
      }

      ${Toggle} {
        background: ${gray50};
      }
    }
  }

  &:focus {
    ~ ${ToggleWrapper} > ${Toggle} {
      box-shadow: 0 0 0 3px ${focusShadow};
    }
  }
`;
const Label = styled.label`
  align-items: center;
  color: ${gray800};
  cursor: pointer;
  display: inline-flex;
  font-family: ${fontSemiBold};
  font-size: ${labelFontSize};

  &:not(:last-of-type) {
    ${({
  horizontal
}) => horizontal ? `margin-right: ${size14};` : `margin-bottom: ${size8}`}
  }
`;
export const Switch = /*#__PURE__*/forwardRef(({
  label,
  checked,
  hideLabel = false,
  disabled = false,
  onChange,
  horizontal = false,
  smallLabel = false,
  ...props
}, ref) => {
  const toggleChecked = () => {
    if (!onChange || disabled) return;
    onChange(!checked);
  };
  const ariaAttributes = hideLabel && {
    'aria-label': label
  };
  return /*#__PURE__*/React.createElement(Label, {
    smallLabel,
    horizontal: horizontal,
    "data-testid": "switch-input"
  }, /*#__PURE__*/React.createElement(Input, _extends({
    type: "checkbox"
  }, ariaAttributes, {
    checked: checked,
    disabled: disabled,
    onChange: toggleChecked,
    ref: ref
  }, props)), /*#__PURE__*/React.createElement(ToggleWrapper, {
    hideLabel: hideLabel,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(ToggleTrack, null), /*#__PURE__*/React.createElement(Toggle, {
    disabled: disabled
  })), !hideLabel && label);
});
Switch.displayName = 'Switch';
export default Switch;
//# sourceMappingURL=index.js.map